import { defineStore } from 'pinia'
import request from '@/utils/request'
import { useUserinfoStore } from '@/store/userinfo'

export const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: {
      id: 0,
      nickName: '',
      sex: 'male',
      avatar: '',
      userName: '',
      email: '',
      type: '',
      status: ''
    },
    isLoaded: false
  }),
  
  actions: {
    async fetchUserInfo(params?: any) {
      // 先从localStorage获取用户信息
      const cachedUserInfo = localStorage.getItem('userInfo')
      if (cachedUserInfo && !params) {
        this.userInfo = JSON.parse(cachedUserInfo)
        this.isLoaded = true
        return
      }
      
      try {
        const response = await request.get('/user/info', { params })
        if (response.data.code === 200) {
          const { id, nickName, sex, avatar, userName, email, type, status } = response.data.data
          this.userInfo = {
            id,
            nickName,
            sex,
            avatar,
            userName,
            email,
            type,
            status
          }
          this.isLoaded = true
          // 缓存用户信息
          localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
          // 新增：同步 pinia userinfoStore 的 nickName
          const userinfoStore = useUserinfoStore()
          if (nickName) {
            userinfoStore.setNickName(nickName)
          }
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
    },

    clearUserInfo() {
      this.userInfo = {
        id: 0,
        nickName: '',
        sex: 'male',
        avatar: '',
        userName: '',
        email: '',
        type: '',
        status: ''
      }
      this.isLoaded = false
      // 清除缓存
      localStorage.removeItem('userInfo')
    }
  }
}) 